import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../../models/UserFunctions.js";
import {
  getOrgById,
  getOrgByRef,
  transformInvitesToTable,
} from "../../models/OrgFunctions.js";
import Divider from "../../layout/Divider.js";
import Space from "../../layout/Space.js";
import { useSnackbar } from "notistack";
import sendInvite from "../../api/send/sendInvite.js";
import { useAppContext } from "../../config/AppContext.js";
import {
  convertSecondsToFirestoreTimestamp,
  getDocDataById,
  getDocDataByRef,
  listenCollection,
  queryCollection,
  updateDocDataField,
} from "../../models/DataFunctions.js";

import DataGridFull from "../../tables/DataGridFull.js";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import SmallSpinner from "../../loading/SmallSpinner.js";
import PrimaryButton from "../../buttons/PrimaryButton.js";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import SecondaryButton from "../../buttons/SecondaryButton.js";
import TextField2 from "../../textfields/TextField2.js";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";
import Icon1 from "../../icons/Icon.js";
import TabGPT from "../../tabs/TabGPT.js";
import Dropzone3 from "../../dropzones/DropZone3.js";
import Modal1 from "../../modals/Modal1.js";
import uploadDropZoneTemporary from "../../api/upload/uploadDropZoneTemporary.js";
import getBookShelfUrls from "../../api/presigned/getBookShelfUrls.js";
import uploadBookShelf from "../../api/upload/uploadBookShelf.js";
import Tippy from "@tippyjs/react";

const BookShelf = ({
  userData,
  orgData,
  masterData,
  navigateWorkspace,
  workspaceData,
}) => {
  const { currentUser, loading } = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const saved_data = appState.saved_data;

  const [date, setDate] = useState(null);
  const [selected_folder, setSelectedFolder] = useState(null);
  const [loading_drop, setLoadingDrop] = useState(false);
  const [loading_transfert, setLoadingTransfer] = useState(false);
  const [droppedExists, setDroppedExists] = useState(false);
  const [dropped_files, setDroppedFiles] = useState([]);
  const [bookshelfData, setBookshelfData] = useState([]);
  const [email, setEmail] = useState("");
  const [loadingData, setLoadingData] = useState(true);
  const [loadingDownloadFile, setLoadingDownloadFile] = useState(null);

  // Fonction pour afficher les messages Snackbar
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  // Fonction pour récupérer les données de l'organisation
  const handleFetchData = async () => {
    if (currentUser) {
      try {
        setLoadingData(true);
        if (!workspaceData) {
          setEmail(orgData.contact_email || orgData.email);
        }
        const token = await getOrRefreshFirebaseToken();

        let master = await getOrgById(masterData.id);

        await getBookShelfUrls(master.id, token, prefix);
        if (master.bookshelf_id) {
          let bookshelf = await getDocDataById(
            "bookshelf",
            master.bookshelf_id
          );
          setBookshelfData(bookshelf);
        }
        setLoadingData(false);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de l'organisation:",
          error
        );
        setLoadingData(false);
      }
    }
  };

  const handleSaveFiles = async () => {
    setLoadingTransfer(true);
    const token = await getOrRefreshFirebaseToken();
    await uploadBookShelf(
      dropped_files,
      masterData.id,
      "client",
      token,
      prefix
    );
    setDroppedFiles([]);
    setDroppedExists(false);
    handleClickVariant("Fichiers ajoutés", "success");
    setAddFilesOpen(null);
    await handleFetchData();
    setLoadingTransfer(false);
  };

  const onDropZone = async (files) => {
    setLoadingDrop(true);
    const token = await getOrRefreshFirebaseToken();

    let new_files = [];

    new_files = files.filter(
      (file) => !dropped_files.map((filed) => filed.name).includes(file.name)
    );

    let new_drop_files = [];

    for (let i = 0; i < new_files.length; i++) {
      let res = await uploadDropZoneTemporary(
        token,
        new_files[i],
        new_files[i].name,
        prefix
      );
      let url = res.url;
      let name = res.name;
      new_drop_files = [...new_drop_files, { url: url, name: name }];
    }
    let new_dropped_files = [...dropped_files, ...new_drop_files];
    setDroppedFiles(new_dropped_files);
    setDroppedExists(true);

    setLoadingDrop(false);
  };

  const handleDeleteFile = (file) => {
    if (activeTab === "clients") {
      let files_clients = bookshelfData.files_clients || [];
      let new_files = files_clients.filter((f) => f.id !== file.id);
      setBookshelfData({
        ...bookshelfData,
        files_clients: new_files,
      });
      updateDocDataFieldApi(
        bookshelfData.ref,
        "files_clients",
        new_files,
        prefix
      );
      handleClickVariant("Fichier supprimé de la bibliothèque", "success");
    } else {
      let files_infiltrea = bookshelfData.files_infiltrea || [];
      let new_files = files_infiltrea.filter((f) => f.id !== file.id);
      setBookshelfData({
        ...bookshelfData,
        files_infiltrea: new_files,
      });
      updateDocDataFieldApi(
        bookshelfData.ref,
        "files_infiltrea",
        new_files,
        prefix
      );
      handleClickVariant("Fichier supprimé de la bibliothèque", "success");
    }
  };

  const onDelete = (file) => {
    const new_files = dropped_files.filter((f) => f !== file);
    setDroppedFiles(new_files);
    if (new_files.length === 0) {
      setDroppedExists(false);
    }
  };
  const [addFilesOpen, setAddFilesOpen] = useState(null);
  const [activeTab, setActiveTab] = useState("clients");
  const [files, setFiles] = useState([]);

  const tabs = [
    {
      id: "clients",
      label: "Documents clients",
    },
  ];

  const id = orgData.id;
  useEffect(() => {
    handleFetchData(); // Récupère les données de l'organisation lorsque le composant est monté
  }, [currentUser]);

  if (loading || !currentUser) {
    return <SmallSpinner />; // Affiche un message de chargement
  }

  return (
    <div className="w-full h-full  flex flex-col items-start justify-start overflow-auto pb-20">
      <Modal1 isOpen={addFilesOpen} onClose={() => setAddFilesOpen(null)}>
        <div className="flex flex-col bg-white p-4 rounded-xl w-c700">
          <div className="flex flex-row justify-between">
            <div className="text-h2 ">Ajouter des fichiers</div>
            <SecondaryButton onClick={() => setAddFilesOpen(null)}>
              Fermer
            </SecondaryButton>
          </div>
          <Space y={20} />
          <div className="flex flex-col gap-2">
            <div className="flex max-w-c900">
              <Dropzone3
                onDrop={onDropZone}
                files={dropped_files || []}
                onDelete={onDelete}
                loading={loading_drop}
              ></Dropzone3>
            </div>
            <Space y={20} />
            <div className="flex flex-row justify-end">
              <PrimaryButton
                onClick={handleSaveFiles}
                disabled={!droppedExists || loading_drop || loading_transfert}
              >
                Ajouter les fichiers{" "}
                {loading_transfert && (
                  <SmallSpinner loading={true}></SmallSpinner>
                )}
              </PrimaryButton>
            </div>
          </div>{" "}
        </div>
      </Modal1>
      <div className="flex flex-col w-full pl-4">
        <div className="text-hx font-medium text-left mb-2">Bibliothèque</div>
        {!workspaceData && (
          <div className="flex flex-col gap-2">
            <div className="mb-4 mt-2">
              <TabGPT
                tabs={tabs}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
            </div>
            <PrimaryButton
              disabled={false}
              onClick={() => setAddFilesOpen(activeTab)}
              className={`w-fit`}
            >
              Ajouter des fichiers
            </PrimaryButton>

            {loadingData && <SmallSpinner></SmallSpinner>}

            <div className="flex flex-col gap-2 mt-2">
              {activeTab === "clients" &&
                bookshelfData?.files_clients &&
                bookshelfData?.files_clients.map((file, index) => (
                  <div key={index} className="flex flex-row gap-2">
                    <FileBookShelf
                      file={file}
                      onClick={() => {
                        setLoadingDownloadFile(file.id);

                        setTimeout(() => {
                          window.open(file.url);
                          setLoadingDownloadFile(null);
                        }, 1000);
                      }}
                      loadingDownloadFile={loadingDownloadFile}
                    ></FileBookShelf>
                    <SecondaryButton onClick={() => handleDeleteFile(file)}>
                      <Icon1 icon_name="delete" size={18} fill="grey"></Icon1>
                    </SecondaryButton>
                  </div>
                ))}
            </div>
          </div>
        )}
        {workspaceData && (
          <div className="flex flex-col gap-2">
            <div className="text-h3 text-shadow_50">
              Fichiers partagés dans l'espace de travail par {masterData?.name}
            </div>
            {loadingData && <SmallSpinner></SmallSpinner>}
            <div className="flex flex-col gap-2 mt-2">
              {activeTab === "clients" &&
                bookshelfData?.files_clients &&
                bookshelfData?.files_clients.map((file, index) => (
                  <div className="flex flex-row gap-2" key={index}>
                    {/* <SecondaryButton
                      key={index}
                      className="w-fit"
                      onClick={() => window.open(file.url)}
                    >
                      {file.name?.substring(0, 50)}
                    </SecondaryButton> */}
                    <FileBookShelf
                      file={file}
                      onClick={() => {
                        setLoadingDownloadFile(file.id);

                        setTimeout(() => {
                          window.open(file.url);
                          setLoadingDownloadFile(null);
                        }, 1000);
                      }}
                      loadingDownloadFile={loadingDownloadFile}
                    ></FileBookShelf>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default BookShelf;

export const FileBookShelf = ({
  file,
  onClick,
  loadingDownloadFile,
  file_name,
  tippy_content = "Télécharger le fichier",
}) => {
  return (
    <div className="flex flex-row gap-2 cursor-pointer" onClick={onClick}>
      <Tippy content={tippy_content} className="custom-tooltip" delay={500}>
        <div className="flex flex-col">
          <div className="text-h3 flex flex-row justify-center hover:animate-fade-repeat items-center gap-3 hover:font-medium text-wrap text-indigo-500 bg-indigo-50 rounded-xl p-2 px-4">
            {loadingDownloadFile === file.id ? (
              <SmallSpinner></SmallSpinner>
            ) : (
              <Icon1 icon_name="file" fill="#6366f1" size={22}></Icon1>
            )}

            <div className="flex flex-col justify-start items-start">
              <div className="text-h3">
                {file_name
                  ? file_name
                  : file?.name.length > 200
                    ? file?.name.substring(0, 200) + "..."
                    : file?.name}
              </div>
              <div className="text-h5 text-shadow_50">
                {
                  // file size in kB
                  Math.round(file?.octets / 1000)
                }{" "}
                Ko
              </div>
            </div>
          </div>
        </div>
      </Tippy>
    </div>
  );
};
